<template>
  <v-dialog
    v-model="value"
    width="1200"
    content-class="menu-item-info-popup"
    @close="close"
  >
    <v-card class="menu-item-info-popup_inner">
      <loader v-if="loading" absolute />
      <v-btn
        depressed
        class="menu-item-info-popup_close"
        small
        color="#F1F3F6"
        @click="close"
      >
        <font-awesome-icon icon="times" />
      </v-btn>

      <div class="menu-item-popup-card">
        <div class="food-info-section d-flex justify-space-between">
          <div class="food-image d-flex align-center justify-center">
            <!--            <div class="badge-left d-flex flex-column align-center">
              <component :is="getLeftSticker" />
              <icon-doubling v-if="isDoubling"/>
            </div>

            <div class="badge-right d-flex flex-column align-center">
              <component :is="getRightSticker" />
            </div>-->
            <img v-if="menuItem.imageOriginal" :src="menuItem.imageOriginal" :alt="menuItem.name" />
            <font-awesome-icon
              v-if="!menuItem.image"
              icon="utensils"
              class="no-image"
            />
          </div>

          <div class="food-info">
            <span class="window-title font-weight-medium">
              {{ menuItem.name }}
            </span>
            <div class="description-section">
              <!--              <span class="label">Описание:</span>-->
              <span class="description">{{ menuItem.description }}</span>
            </div>
            <span class="label">Состав:</span>
            <span class="composition">{{ menuItem.composition }}</span>
            <div class="food-characteristics d-flex a-center">
              <div class="characteristic">
                <span class="label">Вес:</span>
                <span class="unit font-weight-medium">
                  <font-awesome-icon icon="weight-hanging" />
                  {{ getWeight }}
                </span>
              </div>
              <div class="characteristic">
                <span class="label">Калорийность</span>
                <span class="unit font-weight-medium">{{ getCalories }}</span>
              </div>
              <div class="characteristic">
                <span class="label">Белки</span>
                <span class="unit font-weight-medium">{{ getProteins }}</span>
              </div>
              <div class="characteristic">
                <span class="label">Жиры</span>
                <span class="unit font-weight-medium">{{ getFats }}</span>
              </div>
              <div class="characteristic">
                <span class="label">Углеводы</span>
                <span class="unit font-weight-medium">{{ getCarbohydrates }}</span>
              </div>
            </div>

            <div class="food-price">
              <v-row class="d-flex align-end">
                <v-col sm="6">
                  <span class="price-label">Стоимость:</span>
                  <span class="price font-weight-medium">{{ menuItem.price | amountStringWithCurrency }}</span>
                </v-col>
                <v-col sm="6">
                  <div v-if="foxCoinsAdd" class="d-flex align-center bonus-label-container">
                    <icon-bonus />
                    <div class="d-flex">
                      <span class="bonus-label">Бонусов за покупку:  &nbsp;</span>
                      <span class="bonus font-weight-medium">{{ foxCoinsAdd | amountStringWithCurrency }}</span>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </div>

            <div class="button-group food-item-footer">
              <v-row>
                <v-col
                  sm="10"
                  offset-sm="2"
                  offset-md="0"
                  xl="6"
                  md="6"
                >
                  <v-btn
                    v-if="menuItem.modifications && menuItem.modifications.length"
                    class="button button-half font-weight-medium"
                    depressed
                  >
                    <span class="icon">+M</span>
                    {{ getModificationName }}
                    <span class="price">{{ getModificationPrice | amountStringWithCurrency }}</span>
                  </v-btn>
                </v-col>
                <v-col
                  sm="10"
                  offset-sm="2"
                  offset-md="0"
                  xl="6"
                  md="6"
                  class="text-right"
                >
                  <v-btn
                    v-if="activated"
                    class="button button-add font-weight-medium remove"
                    dark
                    depressed
                    @click="$emit('remove', menuItem.id)"
                  >
                    <span
                      class="button-add-title d-flex align-center justify-space-between "
                    >
                      <font-awesome-icon icon="trash" />
                      <span> Удалить из меню</span>
                    </span>
                  </v-btn>
                  <v-btn
                    v-else
                    class="button button-add font-weight-medium"
                    dark
                    depressed
                    @click="$emit('add', menuItem.id)"
                  >
                    <span
                      class="button-add-title d-flex align-center justify-space-between"
                    >
                      <font-awesome-icon icon="plus" />
                      <span>Добавить в меню</span>
                    </span>
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
  import IconStop from '@/components/aside/icons/IconStop.vue'
  import Loader from '@/components/loader/Loader.vue'
  import EnumValueSelectField from '@/components/ui/crud/fields/EnumValueSelectField.vue'
  import StopListReason from '@/models/enums/StopListReason'
  import SnackbarMessage from '@/mixins/snackbar-message'
  import IconDoubling from '@/components/order-processing/order-components/icons/IconDoubling.vue'
  import FoodCard from '@/components/order-processing/order-components/first-step/FoodCard.vue'
  import IconBonus from '@/components/icons/IconBonus.vue'

  export default {
    name: 'MenuItemInfoPopup',
    components: {
      IconBonus,
      FoodCard,
      IconDoubling,
      EnumValueSelectField,
      Loader,
      IconStop,
    },
    mixins: [SnackbarMessage],
    emits: [
      'confirm',
      'close',
    ],
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      menuItem: {
        type: Object,
        default: () => ({}),
      },
      activated: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        reason: null,
      }
    },
    computed: {
      getModificationName () {
        return this.menuItem.modifications[0].modification
          ? this.menuItem.modifications[0].modification.name
          : '–'
      },
      getModificationPrice () {
        return this.menuItem.modifications[0].modification &&
          this.menuItem.modifications[0].actualPrice
          ? this.menuItem.modifications[0].actualPrice
          : null
      },
      foxCoinsAdd () {
        return this.menuItem.foxCoinsAdd
      },
      getCalories () {
        return this.menuItem.technicalCard
          ? this.menuItem.technicalCard.calories + ' кКал'
          : '–'
      },
      getCarbohydrates () {
        return this.menuItem.technicalCard
          ? this.menuItem.technicalCard.carbohydrates + ' г'
          : '–'
      },
      getWeight () {
        return this.menuItem.technicalCard
          ? this.menuItem.technicalCard.weight + ' г'
          : '–'
      },
      getFats () {
        return this.menuItem.technicalCard ? this.menuItem.technicalCard.fats + ' г' : '–'
      },
      getProteins () {
        return this.menuItem.technicalCard
          ? this.menuItem.technicalCard.proteins + ' г'
          : '–'
      },
      isDoubling () { return this.item && this.menuItem.isDoubling },
    },
    watch: {

    },
    methods: {
      close () {
        this.$emit('close')
        this.$emit('input', false)
      },
    },
  }
</script>

<style scoped lang="less">
.menu-item-info-popup {
  border-radius: 10px;

  .menu-item-popup-card {
    font-size: 13px;
    padding-right: 25px;

    .media-xl({
      font-size: 14px;
    });

    .window-title {
      font-size: 28px;
      line-height: 1;
      margin-bottom: 15px;
      padding-right: 50px;
      display: block;
      font-weight: 500;
    }

    .button-back {
      height: 80px;
      font-size: 15px;
      box-shadow: 0 3px 6px #00000029 !important;

      svg {
        margin-right: 8px;
      }

      svg {
        .fill-svg(#0033ff);
      }
    }

    .food-info-section {
      .food-image {
        position: relative;
        background-color: @menu-item-image-bg;
        //border-radius: 30px;
        max-width: 450%;
        width: 45%;
        padding: 10px;
        margin-right: 25px;
        z-index: 0;
        svg.no-image {
          width: 70px;
          height: 70px;
          opacity: 0.4;
          .fill-svg(@color-primary);
        }

        .media-xl({
          max-width: 432px;
          width: 100%;
          padding: 80px 46px 69px 46px;
        });

        .badge-left {
          position: absolute;
          top: 21px;
          left: 24px;
          z-index: 1;
          svg {
            margin-bottom: 10px;
          }
        }

        .badge-right {
          position: absolute;
          top: 21px;
          right: 24px;
          z-index: 1;
        }

        img {
          //max-height: 242px;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      .food-info {
        padding: 20px 0 8px 0;
        flex: 1;

        .label {
          display: block;
          margin-bottom: 9px;
          font-size: 1.42em;
          line-height: 1;
        }

        .composition {
          display: block;
          margin-bottom: 22px;
          font-size: 1.14em;
          line-height: 1.3;
        }

        .food-characteristics {
          display: flex;
          width: 100%;

          .characteristic {
            flex-grow: 1;
            padding: 5px;
            border-radius: 7px;
            background-color: @color-secondary;
            margin-right: 5px;
            text-align: center;
            margin-bottom: 21px;

            &:last-child {
              margin-right: 0;
            }

            .label {
              font-size: 12px;
              margin-bottom: 5px;
            }

            .unit {
              font-size: 13px;
              line-height: 1;
            }
          }

          .media-xl({
            display: block;

            .characteristic {
              padding: 11px 18px 16px 18px;
              border-radius: 15px;
              margin-right: 10px;

              .label {
                font-size: 16px;
                margin-bottom: 10px;
              }

              .unit {
                font-size: 16px;
                line-height: 1;
              }
            }
          });
        }

        .food-price {
          margin-bottom: 28px;

          .price-label {
            display: block;
            font-size: 1.7em;
            line-height: 1;
          }

          .price {
            font-size: 3.3em;
            line-height: 1.1;
          }

          .bonus-label-container {
            svg {
              margin-right: 10px;
            }
            line-height: 1.1;
            margin-bottom: 10px;
          }

          .bonus-label {
            display: block;
            font-size: 1.14em;
            line-height: 1.3;
          }

          .bonus {
            display: block;
            font-size: 1.5em;
            line-height: 1;
          }
        }

        .button-group {
          .button {
            height: 5.7em;
            font-size: 1em;
            line-height: 1.2;
            border-radius: 10px;

            &.button-half {
              background-color: @color-secondary;

              .icon {
                display: inline-block;
                padding: 6px 5px;
                margin-right: 12px;
                border-radius: 6px;
                background-color: @color-primary;
                color: #ffffff;
              }

              .price {
                display: inline-block;
                margin-left: 19px;
              }
            }

            &.button-add {
              background-color: @color-primary;

              &.remove {
                background-color: @color-pink;
              }

              .button-add-title {
                svg {
                  width: 19px;
                  height: 19px;
                  margin-right: 10px;
                }

                .price {
                  margin-left: 25px;
                }
              }

            }
          }
        }
      }
    }

    .description-section {
      margin-bottom: 25px;
      .label {
        display: block;
        font-size: 1.7em;
        line-height: 1;
        margin-bottom: 14px;
      }
      .description {
        display: block;
        font-size: 1.14em;
        line-height: 1.3;
      }
    }

    .similar-food-section {
      margin-bottom: 30px;
      .label {
        display: block;
        font-size: 1.7em;
        line-height: 1;
      }
    }
  }

  &_inner {
    padding: 0;
    border-radius: 10px;
    overflow: hidden;
  }

  &_close {
    position: absolute;
    width: 35px;
    height: 35px;
    right: 10px;
    top: 10px;
    padding: 0 !important;
    min-width: 35px;
  }

  &_title {
    font-size: 24px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 30px;
  }

  &_source {
    margin-bottom: 40px;
  }

  &_image {
    border-radius: 10px;
    overflow: hidden;

    .no-img {
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: center;
      font-size: 70px;
      min-height: 145px;
      color: #f4c99e;
    }
  }

  &_reason {
    padding-top: 10px;
    p {
      font-weight: 500;
      font-size: 16px;
      text-align: center;
      margin-bottom: 20px;
    }
  }

  &_actions {
    display: flex;
    padding: 0 12%;

    &_buttons {
      flex-grow: 1;
      display: flex;
      align-items: center;
    }
  }

  &_btn {
    flex-grow: 1;
    flex-basis: calc(50% - 40px);
    font-weight: 500;
    font-size: 20px;
    text-transform: none;
    margin: 0 10px;

    &__confirm {
      color: white;
      svg {
        height: 28px;
        width: 40px;
      }
    }
  }

}
</style>
